export default {"src":"/_next/static/media/ExpertPhysicians.0996c5ff.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};